module.exports = __webpack_public_path__ + "static/media/Caja.ba048b7c.png";